import { RegionTypes } from '../constants/regionType';

const DETECTED_REGION =
	process.env.REACT_APP_REGION === RegionTypes.SaudiArabia
		? RegionTypes.SaudiArabia
		: RegionTypes.Global;

export class RegionService {
	currentRegion() {
		return DETECTED_REGION;
	}
}
